import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators,FormsModule } from '@angular/forms';
import { UserService } from '../../service/user.service';
import { ToastrService } from 'ngx-toastr';
import { GalleryComponent } from '../../components/gallery/gallery.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GalleryComponent
  ],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  contactForm: FormGroup;
  submitted = false;
  success = false;


  constructor(private fb: FormBuilder, private userService: UserService, private toastr: ToastrService) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      subject: ['', Validators.required],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.contactForm.valid) {
      this.userService.contactUs(this.contactForm.value)
        .subscribe((res) => {
          this.submitted = false;
          if (res.meta.status_code == 1) {
            this.toastr.success(res.meta.status_message)
            // this.success = true;
            // setTimeout(() => {
            //   this.success = false;
            // }, 3000);
            this.contactForm.reset();
          }
          else
            this.toastr.error(res.meta.status_message)
        })
    }
  }

  get f() {
    return this.contactForm.controls;
  }
}
